(function (angular) {
    'use strict';

    angular.module('channels.email')
        /**
         *
         */
        .controller('DomainsCtrl',
            ['$scope', 'emailSettings', 'emailSettingsService', '$stateParams', '$uibModalInstance',
                function ($scope, emailSettings, emailSettingsService, $stateParams, $uibModalInstance) {

                    $scope.emailSettings = emailSettings;

                    $scope.getDomainDetails = function (domain) {

                        emailSettingsService.getCustomDomain($stateParams.pickedApiSpaceId, domain.domain)
                            .then(function (result) {
                                domain.showDetails = true;
                                domain.ips = result.ips;
                            });
                    }

                    $scope.cancel = function () {
                        $uibModalInstance.dismiss('cancel');
                    };

                }]);

})(window.angular);
